var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSmallBaggage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 17,
    viewBox: "0 0 13 17",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.33 10.458v-5.7A2.265 2.265 0 0 0 10.07 2.5H8.272V.557A.557.557 0 0 0 7.716 0H5.544a.555.555 0 0 0-.553.556v1.942h-1.8A2.267 2.267 0 0 0 .93 4.76v5.7a.76.76 0 0 0-.647.746v4.187c0 .393.3.707.68.755.09.479.492.853.997.853h9.338c.505 0 .91-.374.997-.853a.77.77 0 0 0 .68-.755v-4.187a.765.765 0 0 0-.646-.748M6.102 1.111h1.056v1.388H6.101zm2.591 11.62a.256.256 0 0 1-.256.257H4.823a.255.255 0 0 1-.253-.258v-.509c0-.139.114-.253.253-.253h3.613c.142 0 .256.114.256.253zm1.256-5.26c0 .14-.114.255-.256.255H3.566a.255.255 0 0 1-.253-.255v-.8c0-.14.114-.255.253-.255h6.125c.142 0 .256.115.256.255v.8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmallBaggage);
export default __webpack_public_path__ + "static/media/smallBaggage.4f2ffcda1db7c6ec3373815a60a3c667.svg";
export { ForwardRef as ReactComponent };